<ion-item [button]="true" [detail]="true">

  <ion-thumbnail slot="start">
    <img [src]="item.user.profile_picture || 'assets/img/empty-img/no_user.png'" alt="">
  </ion-thumbnail>

  <ion-label>

    <div class="title">{{ item.user.name }}</div>

    <div class="description data">
      <yu-icon name="clock-user"></yu-icon>
      <p>{{ item.total_time }} h | {{ item.total_entries }} {{ item.total_entries > 1 ? 'fichajes' : 'fichaje' }}</p>

      @if (hasAutomatic) {
        <yu-icon name="warning" color="warning"></yu-icon>
      }
    </div>

  </ion-label>

</ion-item>
